var _path, _ellipse, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinRestaurant(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 80,
    viewBox: "0 0 55 80",
    color: "#484848",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.1562 26.4039C54.1562 40.9864 27.1562 80 27.1562 80C27.1562 80 0.15625 40.9864 0.15625 26.4039C0.15625 11.8214 12.2446 0 27.1562 0C42.0679 0 54.1562 11.8214 54.1562 26.4039Z",
    fill: "currentColor"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.7531,
    cy: 26.0099,
    rx: 18.5373,
    ry: 18.1281,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1562 17.8999C24.3562 17.8999 17.3562 18.2499 18.0562 18.9499L26.4562 27.6999V33.2999C26.4562 34.6999 22.2562 33.9999 22.2562 36.0999H32.0562C32.0562 33.9999 27.8562 34.6999 27.8562 33.2999V27.6999L36.2562 18.9499C36.9562 18.2499 29.9562 17.8999 27.1562 17.8999ZM27.1562 19.2999C30.6562 19.2999 33.8062 19.6499 33.8062 19.6499L32.7562 20.6999H21.5562L20.5062 19.6499C20.5062 19.6499 23.6562 19.2999 27.1562 19.2999Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinRestaurant);
export default __webpack_public_path__ + "static/media/pin-restaurant.e6748720407c58146fe5129a59b9125e.svg";
export { ForwardRef as ReactComponent };